import { SET_PANEL } from "@Actions/types";

export default function reducer(state = { activePanel: "list" }, action) {
	const { type, payload } = action;
	switch (type) {
		case SET_PANEL:
			return { ...state, activePanel: payload.data };

		default:
			return state;
	}
}
